import { useProductCatalog } from '@hooks/useProductCatalog'
import ProductCard from '@components/ProductCard'
import SocialLinks from '@components/SocialLinks'
import styles from '@styles/ShopPage.module.css'
import SearchBar from '@components/SearchBar'
import { useState, useMemo } from 'react'
import Loading from '@components/Loading'
import Navbar from '@components/Navbar'

const ShopPage = () => {
  const { products, loading } = useProductCatalog()
  const [searchTerm, setSearchTerm] = useState('')
  const [searchFilter, setSearchFilter] = useState('brand')

  const groupedProducts = useMemo(() => {
    const filtered = products.filter(product => {
      if (searchFilter === 'category') {
        return product.category.toLowerCase().includes(searchTerm.toLowerCase())
      } else if (searchFilter === 'brand') {
        return product.brand.toLowerCase().includes(searchTerm.toLowerCase())
      } else if (searchFilter === 'reference') {
        return product.reference
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      } else if (searchFilter === 'price') {
        return product.price.toString().includes(searchTerm)
      }
      return true
    })

    return filtered.reduce((acc, product) => {
      if (!acc[product.category]) {
        acc[product.category] = []
      }
      acc[product.category].push(product)
      return acc
    }, {})
  }, [products, searchTerm, searchFilter])

  if (loading) return <Loading />

  return (
    <div className={styles.shopPage}>
      <Navbar className={styles.shopNavbar} />
      <main className={styles.mainContent}>
        <h1 className={styles.title}>Nuestra Tienda</h1>

        <SearchBar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          searchFilter={searchFilter}
          setSearchFilter={setSearchFilter}
        />

        {Object.entries(groupedProducts).map(([category, categoryProducts]) => (
          <div
            key={category}
            className={`${category === 'Lentes' ? styles.lentesCategory : styles.categorySection}`}
          >
            <h2 className={styles.categoryTitle}>{category}</h2>
            <div className={`${category === 'Lentes' ? styles.lentesGrid : styles.grid}`}>
              {categoryProducts.map((product, index) => {
                const imageUrl = typeof product.image === 'object' ? product.image.url : product.image
                return (
                <ProductCard
                  key={product.id}
                  id={product.id}
                  image={imageUrl}
                  brand={product.brand}
                  reference={product.reference}
                  price={product.price}
                  active={product.active}
                  isFirstImage={index === 0}
                  isLens={category === 'Lentes'}
                />
              )
              })}
            </div>
          </div>
        ))}
      </main>
      <footer className={styles.footer}>
        <SocialLinks />
      </footer>
    </div>
  )
}

export default ShopPage
